export default "__VITE_ASSET__3420b204__"